import React, { FC } from 'react';
import InView from 'react-intersection-observer';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Wrapper = styled.div`
  text-align: center;
  padding: var(--spacing-03);

  > div {
    background: var(--white-100);
    border-radius: var(--border-radius-curved);
    box-shadow: var(--shadow-02);
    display: inline-block;
    font-size: var(--font-size-sm);
    line-height: var(--line-height-caption-01);
    letter-spacing: 0.32px;
    min-width: 110px;
    padding: var(--spacing-03) var(--spacing-05);
    position: relative;
    z-index: 1;
  }
`;

export const FetchConversationRow: FC<{
  fetchAllConversation(): void;
}> = ({ fetchAllConversation }) => (
  <Wrapper>
    <InView onChange={(inView) => inView && fetchAllConversation()} as="div">
      <FormattedMessage id="conversations.fetching_data" />
    </InView>
  </Wrapper>
);
